import {
  ActivityChangeOptions,
  ActivityUserItem,
  createActivityChangeExtension,
} from '@spotify/plugin-confidence-activity-react';

const toIdentityName = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && value !== null) {
    const obj = value as Record<string, unknown>;
    if (typeof obj.name === 'string') return obj.name;
  }
  return undefined;
};

const OwnerUpdates = ({ change }: ActivityChangeOptions) => {
  return (
    <ActivityUserItem
      oldValue={toIdentityName(change.oldValue)}
      newValue={toIdentityName(change.newValue)}
    />
  );
};

export const OWNER_CHANGE_EXTENSION = createActivityChangeExtension({
  id: 'owner-change',
  predicate: ({ change }) => change.fieldPath === '/owner',
  render: OwnerUpdates,
  values: change => ({
    oldValue: { owner: change.oldValue },
    newValue: { owner: change.newValue },
  }),
});
